var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19.0001,
    r: 18.5,
    stroke: "#8DC63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5569 21.906L22.1019 22.359C22.1019 22.359 21.0189 23.435 18.0639 20.497C15.1089 17.559 16.1919 16.483 16.1919 16.483L16.4779 16.197C17.1849 15.495 17.2519 14.367 16.6349 13.543L15.3749 11.86C14.6109 10.84 13.1359 10.705 12.2609 11.575L10.6909 13.135C10.2579 13.567 9.96786 14.125 10.0029 14.745C10.0929 16.332 10.8109 19.745 14.8149 23.727C19.0619 27.949 23.0469 28.117 24.6759 27.965C25.1919 27.917 25.6399 27.655 26.0009 27.295L27.4209 25.883C28.3809 24.93 28.1109 23.295 26.8829 22.628L24.9729 21.589C24.1669 21.152 23.1869 21.28 22.5569 21.906Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.b2189625aeb3447c11e58bb4e948de73.svg";
export { ForwardRef as ReactComponent };